<template>

    <div class="row g-32 mm-none " style="position: fixed; top: 20px; width: 23%;" >

        <!-- <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="Search creators..." aria-label="Recipient's username" aria-describedby="button-addon2" style="border-radius: 15px; border-top-right-radius: 0; border-bottom-right-radius: 0;">
            
            <button class="btn btn-icon-only btn-outline-primary" style="border-radius: 15px ; margin-left: 0px; border-top-left-radius: 0; border-bottom-left-radius: 0;">
                <i class="hp-text-color-dark-0 iconly-Light-Search" style="font-size: 15px;"></i>
            </button>

        </div> -->

        <ul class="nav nav-tabs mb-12" id="pills-tab" role="tablist" >
            <li class="nav-item" role="presentation">
                <h6 style="padding-bottom: 10px;" class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"> Leaderboard</h6>
            </li>
            
        </ul>

        <div class="tab-content" id="leaderBoardTabContent" >

            <div class="tab-pane fade show active" id="leader" role="tabpanel" aria-labelledby="leader-tab" >

                <div v-for="popular in popularList" :key="popular.id">

                    <div class="col" style="display: flex; justify-content: flex-start; align-items: center; width: 100%; cursor: pointer;" @click="profileClick(popular.userId, popular.userName)" >

                    <span v-if="popular.number == 1" style="font-size: 22px; margin-right: 35px; color: #ffbc00;">#1</span>
                    <span v-else-if="popular.number == 2" style="font-size: 22px; margin-right: 35px; color: #9146ff;">#2</span>
                    <span v-else-if="popular.number == 3" style="font-size: 22px; margin-right: 35px; color: #574630;">#3</span>
                    <span v-else style="font-size: 22px; margin-right: 35px;" class="hp-p1-body">#{{ popular.number }}</span>
                    <!-- <img src="../assets/img/first.png" alt="" style="width: 50px; margin-right: 25px;"> -->

                    <div class="row align-items-center">

                        <div class="w-auto px-0">
                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 58px; height: 58px; ">

                                <img :src="popular.profilePic" class="hp-img-cover" style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-width: 0.5px; border-style: solid; border-color: #c3c3c3;">
                            </div>
                        </div>

                        <div class="w-auto ms-8 px-0 mt-12">

                            <div style="display: flex; justify-content: center; align-items: center;">

                                <span class="d-block hp-text-color-black-30 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif;  text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;">{{ popular.fullName }}</span>

                                <span v-if="popular.userType == 'model'">
                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                </span>

                                <span v-if="popular.sexuality == 'gay'" >
                                    <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                </span>

                                <span v-if="popular.sexuality == 'lesibian'">
                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                </span>

                                <span v-if="popular.sexuality == 'bisexual'">
                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                </span>

                            </div>

                            <p style="font-size: 12px;  text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ popular.userName }} </p>

                        </div>

                    </div>

                    </div>

                    <div class="divider mt-18 mb-16 "></div>

                </div>

            </div>

        </div>


    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<style scoped>

    .card-overlay2 {
        background: rgba(0, 0, 0, 0.6);
        border-radius: 20px;
    }

    .xxsh{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.29);
    }

    
</style>

<script>
    import { doc,  collection, query, where, getDoc, getDocs, serverTimestamp, orderBy,  limit, updateDoc } from "firebase/firestore";
    import { getAuth } from "firebase/auth";
    import { db } from '@/firebase';

    export default {

        data() {

            return {

                loadingText: "",
                errorText: "",
                successText: "",
                popularList: [],

                

            }

        },

        mounted(){
            this.getPopular();
        },

        methods: {

            closeE() {
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS() {
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            kFormatter(num) {
                return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

            },

            detectMob() {
                return ( ( window.innerWidth <= 600 ) );
            },

            async getUserInfo(){

                if(this.$route.name == "other-profile"){
                    this.isOther = true;
                }

                if(sessionStorage.getItem("noUserName") == "noUserName"){
                    return;
                }

            },

            profileClick(userId, userName) {

                const auth = getAuth();

                if (auth.currentUser.uid == userId) {
                    this.$router.push({ name: 'profile' });
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: userName } });
                return;

            },

            async getPopular(){

                if(this.detectMob()){
                    return;
                }

                const q = query(collection(db, "Users"), where("type", '==', "model"), orderBy("fanCountN"), limit(7));
                const querySnapshot = await getDocs(q);

                let i = 0;

                if (querySnapshot.docs.length > 0){

                    querySnapshot.forEach((doc) => {

                        i++

                        this.popularList.push(
                            {

                                number: i,
                                id: doc.data().userId,
                                userId: doc.data().userId,
                                fullName: doc.data().name,
                                userName: doc.data().displayId, 
                                profilePic: doc.data().profilePic,
                                profileBackground: doc.data().profileBackground,

                                sexuality: doc.data().sexuality,
                                postCount: this.kFormatter(doc.data().postCount),
                                likes: this.kFormatter(doc.data().likes),
                                fanCount: this.kFormatter(doc.data().fanCount),
                                dateJoined: doc.data().dataJoined,
                                userType: doc.data().type

                            }
                        )

                    })

                }

            }

        }

    }
</script>